module.exports = __webpack_public_path__ + "static/media/microphone.20f445ba.svg";